import { matchPath } from 'react-router-dom';
import type { Route } from '@/services/router';
import type { LocalCommand } from './local-commands';

export type Navigate = (url: string) => void;

const NUMERIC_ROUTE_ID = /^\d+$/;

export function matchesCurrentWorkspaceRoute(pathname: string, pattern: Route, workspaceId: number): boolean {
  const matchedWorkspaceId = matchPath(pattern, pathname)?.params.workspaceId;
  return matchedWorkspaceId === 'last' || matchedWorkspaceId === String(workspaceId);
}

export function getNumericRouteParamFromPathname({
  pathname,
  workspaceId,
  route,
  paramName,
}: {
  pathname: string;
  workspaceId: number;
  route: Route;
  paramName: string;
}): string | null {
  if (workspaceId === 0) return null;

  const params = matchPath({ path: route, end: false }, pathname)?.params;
  const matchedWorkspaceId = params?.workspaceId;
  const routeId = params != null ? params[paramName as keyof typeof params] : undefined;
  const isCurrentWorkspace = matchedWorkspaceId === 'last' || matchedWorkspaceId === String(workspaceId);

  if (routeId == null || !isCurrentWorkspace || !NUMERIC_ROUTE_ID.test(routeId)) return null;

  return routeId;
}

export function addRoutingCommand(
  commands: LocalCommand[],
  currentPathname: string,
  navigate: Navigate,
  destination: string,
  command: Omit<LocalCommand, 'onSelect'>,
): void {
  if (new URL(destination, window.location.origin).pathname === currentPathname) return;

  commands.push({
    ...command,
    onSelect: () => navigate(destination),
  });
}
